import { Input } from "@/components/ui/input";

interface FailureThresholdFieldProps {
  value: string;
  onValueChange: (value: string) => void;
  passThresholdPercent: number;
}

export const FailureThresholdField = ({
  value,
  onValueChange,
  passThresholdPercent,
}: FailureThresholdFieldProps) => (
  <div className="flex items-center justify-between gap-4 rounded-lg border border-border/70 px-3 py-3">
    <div>
      <div className="text-sm font-medium text-foreground">Failure threshold</div>
      <div className="text-xs text-muted-foreground">
        Scores below this percentage fail. Scores between this and {passThresholdPercent}% need
        review.
      </div>
    </div>
    <div className="relative w-24 shrink-0">
      <Input
        value={value}
        onChange={event => onValueChange(event.target.value)}
        className="pr-7 text-center"
        inputMode="decimal"
        placeholder="60"
      />
      <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">
        %
      </span>
    </div>
  </div>
);
